import { render, staticRenderFns } from "./formulator-extension-additives.vue?vue&type=template&id=56254a3e&scoped=true&"
import script from "./formulator-extension-additives.vue?vue&type=script&lang=js&"
export * from "./formulator-extension-additives.vue?vue&type=script&lang=js&"
import style0 from "./formulator-extension-additives.vue?vue&type=style&index=0&id=56254a3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56254a3e",
  null
  
)

export default component.exports